import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BasePage } from "pages/base-page";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { Observable } from "rxjs/Observable";
import { SearchResult } from "../../models/messaging/chat";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class UserProfileService extends BasePage {
  baseUserProfileUrl: string;
  searchEndpoint: string;
  rolesEndpoint: string;

  constructor(
    public http: HttpClient,
    public stateData: StateManagementService,
    config: ConfigurationService
  ) {
    super(stateData);
    this.baseUserProfileUrl = config.getConfig().apiUrl + "/user-profile";
    this.searchEndpoint = this.baseUserProfileUrl + "/search";
    this.rolesEndpoint = this.baseUserProfileUrl + "/roles";
  }

  getUsersByRole(request: any) {
    return this.http.post(this.searchEndpoint, request);
  }

  postRolePermission(request: any) {
    return this.http.post(this.rolesEndpoint, request);
  }

  updateCurrentOrg(selectedOrgId: string) {
    let url: string = this.baseUserProfileUrl + "/currentOrg/" + selectedOrgId;
    return this.http.post(url, selectedOrgId);
  }

  getUserOrganizations(userId: string) {
    let request: any = {
      entityType: "USER",
      mustFields: [{ name: "userId", value: userId }],
    };
    return this.http.post(this.searchEndpoint, request);
  }

  getContactsForMessaging(
    tenantId: string,
    query: string
  ): Observable<SearchResult> {
    let request: any = {
      entityType: "USER",
      mustFields: [{ name: "primaryOrgId", value: tenantId }],
      search: query,
    };
    return this.http.post<SearchResult>(this.searchEndpoint, request);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-profile/user-profile.service.ts